import { css } from 'styled-components';
import token from 'styled-token';
import { StyledDropdown } from '../../components/Dropdown/Dropdown.styles';
import { StyledListbox } from '../../components/Listbox/Listbox.styles';
export var ComboboxMixin = function ComboboxMixin(props) {
  var fluidDropdown = props.fluidDropdown;
  if (fluidDropdown) {
    return token({
      dropdownWidth: 'Combobox.Dropdown.width',
      listboxBorder: 'Combobox.Listbox.border'
    }, function (_ref) {
      var _ref$dropdownWidth = _ref.dropdownWidth,
        dropdownWidth = _ref$dropdownWidth === void 0 ? '100%' : _ref$dropdownWidth,
        _ref$listboxBorder = _ref.listboxBorder,
        listboxBorder = _ref$listboxBorder === void 0 ? 'none' : _ref$listboxBorder;
      return css(["position:relative;", "{width:", ";}", "{border:", ";}"], StyledDropdown, dropdownWidth, StyledListbox, listboxBorder);
    })(props);
  }
  return '';
};